module.exports = __webpack_public_path__ + "img/loginDark.858bc284.svg";